module.exports = __webpack_public_path__ + "img/icon_fanjiansel.4e31d3b1.svg";